import type { RequestConfig } from '@customTypes/index';
import type { PaymentsDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetClubProfilePaymentsRequest = {
  clubId: string;
};

export type GetClubProfilePaymentsParams =
  RequestConfig<GetClubProfilePaymentsRequest>;

export const getClubProfilePayments = async ({
  params,
  config
}: GetClubProfilePaymentsParams) =>
  api.get<PaymentsDto>(`/api/ClubProfile/payments/${params.clubId}`, config);
